import * as TYPES from './auth-actiontypes';
// import { persistStateToSession } from '../../webstorage';

import { getState /* , LOCAL_STORAGE_KEY */ } from './auth-middleware';

const authReducer = (state = getState(), action) => {
  let newState;

  switch (action.type) {
    case TYPES.LOGIN_REQUEST:
      newState = { ...state, ...action.state };
      break;
    case TYPES.LOGIN_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.KIOSK_LOGIN_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.KIOSK_LOGIN_FAILURE:
      newState = { ...state, ...action.state };
      break;
    case TYPES.PATIENTKIOSKUSER_LOGIN_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.PATIENTKIOSKUSER_LOGIN_FAILURE:
      newState = { ...state, ...action.state };
      break;
    case TYPES.LOGIN_FAILURE:
      newState = { ...state, ...action.state };
      break;
    case TYPES.SINGLESIGNON_LOGIN_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.SINGLESIGNON_LOGIN_FAILURE:
      newState = { ...state, ...action.state };
      break;
    case TYPES.TOKEN_UPDATE_REQUEST:
      newState = { ...state, ...action.state };
      break;
    case TYPES.TOKEN_UPDATE_SUCCESS:
      newState = { ...state, ...action.state };
      break;
    case TYPES.TOKEN_UPDATE_FAILURE:
      newState = { ...state, ...action.state };
      break;
    default:
      newState = state;
  }
  // persistStateToSession(LOCAL_STORAGE_KEY, newState);
  return newState;
};

export default authReducer;
